import { Container } from 'react-bootstrap';
import "../style/fpage.css";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useRef } from 'react';
import { useState } from 'react';
export default function Feedback() {
      const [services, setserivces] = useState([
        {id:1,title:"Claudia Schmidt", coment:"Die Fensterreinigung war perfekt! Klare Sicht und keine Streifen. Sehr empfehlenswert!",img:"https://www.bookmarkedhub.com/uploads/authors/search_press/claudia_schmidt/ap_claudia_schmidt_01.jpg"},
        {id:2,title:"Claudia Schmidt", coment:"Sehr gründliche Reinigung. Ein kleiner Bereich wurde übersehen, aber insgesamt bin ich sehr zufrieden.",img:"https://www.hogn.de/wp-content/uploads/2024/09/Profikoch-Markus-Fischer_Prackenbach-1.jpg"},
        {id:3,title:"Julian Kraus", coment:"Die Bodenreinigung hat unsere Praxis wie neu aussehen lassen. Pünktlich und zuverlässig!",img:"https://media.licdn.com/dms/image/v2/D4E03AQGbjUoZinNx9w/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1685092092472?e=2147483647&v=beta&t=FqitmcAAht7L7tpeSGWxulmka0P0fp34RXExFINvsGM"},
        {id:3,title:"Susanne Weber", coment:"Das beste Reinigungsunternehmen, das wir je hatten! Freundliches Team und exzellente Ergebnisse.",img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1X432K5ZzLsqUo2bNTpis9ULrUxBaitN4PA&s"},
      ]); 
    const sliderRef = useRef(null);
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      swipe: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
  
    const nextSlide = () => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    };
    const prevSlide = () => {
        if (sliderRef.current) {
          sliderRef.current.slickPrev();
        }
      };
      
  return (
    <div className='feedback'>
      <Container>
        <div className='inside-feedback'>
            <div className='i-f-l'>
                <h2>Feedback zu ihren <br/> Erfahrungen mit uns</h2>
                <p>Lesen Sie die Erfahrungsberichte unserer zufriedenen Kunden. Erfahren Sie, wie unsere Reinigungsdienste ihr Leben und ihr Zuhause verändert haben.</p>
                <div className='f-btn'>
                    <button className='ff-btn' onClick={prevSlide}><i class="fa-solid fa-arrow-left"></i></button>
                    <button className='fff-btn'  onClick={nextSlide}><i class="fa-solid fa-arrow-right"></i></button>
                </div>
            </div>
            <div className='i-f-r'>
       

            <div className='slider-box'>
          <div className='slider-container'>
            <Slider ref={sliderRef} {...settings}>
              {services.map(item => (
                <div key={item.id} className='slide'>
                   <div className='cardm'>

                    <div className='inside-card'>

                    <div className='frist'> <img src={item.img} alt="" /></div>
               <div className='second'>
               <div className='content'>
                        <div className='content-up'>
                            <div>
                                <h4>{item.title}</h4>
                                <div>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    </div>
                            </div>
                            <img src="/images/Quotation.png" alt="" />
                        </div>
                      
                    </div>

               </div>
                    </div>
         
                    <div className='content -down'>
<p>{item.coment}</p>
</div>
                </div>
                </div>
              ))}
            </Slider>
          </div>
      
        </div>


            </div>
        </div>












       




     
      </Container>
    </div>
  );
}
